import { Component, Input } from '@angular/core';
import { GradesProvider } from '../../providers/grades/grades';
import { Grade } from './../../models/Grade';
import { LoadingController, ToastController } from 'ionic-angular';
@Component({
    selector: 'grade-list',
    templateUrl: 'grade-list.html'
})
export class GradeListComponent {

    @Input('stocks') stocks: boolean = false;

    grades: Grade[] = [];
    allGrades: Grade[] = [];
    hasLoaded: boolean = false;

    constructor(
        public gradesCtrl: GradesProvider,
        public loadingCtrl: LoadingController,
        public toastCtrl: ToastController,

    ) {

    }

    ngOnInit(){
        let loader = this.loadingCtrl.create();
        loader.present();

        this.gradesCtrl.getAllGrades(this.stocks).subscribe(grades => {
            this.allGrades = grades;
            this.grades = [];
            this.hasLoaded = true;
            this.loadMoreGrades();
            loader.dismiss();
        }, error => {
            this.toastCtrl.create({ message: error, duration: 3000 }).present();
            loader.dismiss();
        })
    }


    getMoreItems(infiniteScroll) {
        this.loadMoreGrades();
        infiniteScroll.complete();
    }
    loadMoreGrades() {
        let start = this.grades.length;
        let end = start + 14;

        if (end >= this.allGrades.length) {
            end = this.allGrades.length - 1;
        }
        for (let i = start; i <= end; i++) {
            this.grades.push(this.allGrades[i]);
        }
    }
    getMoreItemsButton(event) {
        this.loadMoreGrades();
    }
}



// WEBPACK FOOTER //
// ./src/components/grade-list/grade-list.ts